var scriptTag = document.getElementById("app-min");

if (!scriptTag) {
  console.log("Implementation Error: Footer script tag invalid");
}

var themeUrl = scriptTag.getAttribute("data-theme-url");

requirejs.config({
  baseUrl: themeUrl + "/assets/compiled/js",
  shim: {
    bootstrap: { deps: ["jquery"] }
  },
  paths: {
    jquery: "./lib/jquery",
    jqueryUi: "https://code.jquery.com/ui/1.12.1/jquery-ui",
    bootstrap: "../../../p4/assets/bootstrap/js/bootstrap.bundle.min",
    matchHeight:
      "https://cdnjs.cloudflare.com/ajax/libs/jquery.matchHeight/0.7.2/jquery.matchHeight-min",
    select2:
      "https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.5/js/select2.min",
    scrollTo:
      "https://cdnjs.cloudflare.com/ajax/libs/jquery-scrollTo/2.1.2/jquery.scrollTo.min",
    fancybox:
      "https://cdnjs.cloudflare.com/ajax/libs/fancybox/3.2.5/jquery.fancybox.min",
    aos: "https://cdnjs.cloudflare.com/ajax/libs/aos/2.3.4/aos",
    validate:
      "https://cdnjs.cloudflare.com/ajax/libs/validate.js/0.12.0/validate.min",
    log: "./lib/log",
    map: "./lib/map",
    accordion: "./lib/accordion",
    counter: "./lib/counter",
    video: "./lib/video",
    videoModal: "./lib/video-modal",
    tabs: "./lib/tabs",
  },
  urlArgs: function(id, url) {
    if (url.indexOf("/") == 0 && url.indexOf("//") != 0) {
      var version = /v=[^&]+/.exec(
        document.getElementById("app-min").getAttribute("data-main")
      )[0];
      return (url.indexOf("?") >= 0 ? "&" : "?") + version;
    }
    return "";
  }
});

var dependencies = ["jquery"];

if (initState && initState.modules !== undefined) {
  for (var i = 0; i < initState.modules.length; i++) {
    dependencies.push(initState.modules[i]);
  }
}

//app.js gets added here

//p4.js gets added here
requirejs.config({
	paths: {
		//App specific
		//example: './app/example',
		slick: '../../../lib/slick/slick.min'
	}
});

var appDependencies = ['slick'];

dependencies = dependencies.concat(appDependencies);

requirejs(dependencies, function($, slick) {
	$('.hamburger').on('click', function() {
		var $nav = $('.menu-mobile');
		$nav.toggleClass('open');
	});

	$("[data-role='open-modal']").on('click', function() {
		$('body').addClass('modal-open');
		var $this = $(this);
		$('.modal[data-modal-id="' + $this.data('modal-id') + '"]').show();
	});

	$("[data-role='close-modal']").on('click', function() {
		$('body').removeClass('modal-open');
		$('[data-role="modal"]').hide();
	});

	$(".more-info").on('click', function() {
		var $this = $(this);
		var productNum = 'product-description-' + $this.data('role');

		$('.down').addClass('fa-chevron-right').removeClass('fa-chevron-down down');
		$this.find('.fa-chevron-right').addClass('fa-chevron-down down').removeClass('fa-chevron-right');

		$(".show").removeClass('show');
		$("[data-role='"+ productNum + "']").addClass('show');
		var productOffset = $("[data-role='"+ productNum + "']").offset().top - $('header').outerHeight();
		$([document.documentElement, document.body]).animate({ scrollTop: productOffset }, 1000);
	});

	$(window).on('resize', function () {
		var headerHeight = $('header').outerHeight();
		$('body').css('margin-top', headerHeight);
	});
	$(window).trigger('resize');


	$('.floater').on('click', function() {
		$('.contactform').toggle();
	});

	$('.close-contact').on('click', function() {
		$('.contactform').toggle();
	});

	$('.accordian').on('click', function() {
		$(this).find("i").toggleClass('rotate-90');
		$(this).find('.accordian-content').toggle("fast");
	});

	$(".search-btn").click(function(e) {
    e.preventDefault();
    openSearch();
  });

  $("#search-close").click(function() {
    closeSearch();
  });

  // Open the full screen search box
  function openSearch() {
    document.getElementById("search").style.display = "block";
    $("#search input").focus();
  }

  // Close the full screen search box
  function closeSearch() {
    document.getElementById("search").style.display = "none";
  }

	$('.slick-logos').slick({
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 7,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.iot-solutions').slick({
		arrows: true,
		speed: 300,
		infinite: true,
		slidesToShow: 3,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					arrows: true,
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			}
		]
	});

	$('.slick-typical-applications').slick({
		infinite: true,
		arrows: true,
		speed: 300,
		slidesToShow: 9,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.option-slider').slick({
		arrows: true,
		infinite: true,
		speed: 300,
		slidesToShow: 3,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					variableWidth: false,
					centerMode: true,
				}
			}
		]
	});

	$('.clients').slick({
		arrows: true,
		infinite: true,
		slidesToShow: 1,
		speed: 300
	});
});